/**
 * Licence module IDs.
 * Must match the `codigo` values returned by the GPO licence endpoint
 * and the `moduleId` fields in menu.json.
 * Source: .amigrar/constantes.ts (MENU_ID_MODULO_*)
 */
export const ModuleIds = {
  PRODUCCION: 1,
  RMA: 50,
  AUTORIZACION: 100,
  WEB: 200,
  SERVICIOS: 300,
  ESTADISTICA: 400,
  NOTIFICACIONES: 500,
  PLATAFORMAS: 600,
} as const;

export type ModuleId = (typeof ModuleIds)[keyof typeof ModuleIds];
